"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var VideoStream_1 = __importDefault(require("../CallLayout/VideoStream"));
var __1 = require("../../");
var WindowPortal_1 = __importDefault(require("./WindowPortal"));
var ux_assets_1 = require("@lifesize/ux-assets");
// Note: there are no stylesheets passed to the portal, so style the elements directly
var containerStyle = {
    alignItems: 'center',
    backgroundColor: ux_assets_1.colors.black,
    bottom: 0,
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    width: '100%'
};
var videoStyle = {
    height: 'auto',
    maxHeight: '100vh',
    maxWidth: '100vw',
    minHeight: '100%',
    minWidth: '100vw',
    width: 'auto',
    objectFit: 'contain'
};
var Popout = function (props) {
    var remotePresentationStream = __1.hooks.useMedia().remotePresentationStream;
    return (react_1.default.createElement(WindowPortal_1.default, { windowName: props.windowName },
        react_1.default.createElement("div", { style: containerStyle },
            react_1.default.createElement(VideoStream_1.default, { dataTestId: "lsPopoutVideo", elementId: "lsPopoutVideo", mediaStream: remotePresentationStream, muted: true, style: videoStyle }))));
};
exports.default = Popout;
